export const PDF_NOTE_COLOR_OPTIONS = [
  { value: 'blue', label: 'Синий' },
  { value: 'yellow', label: 'Жёлтый' },
  { value: 'green', label: 'Зелёный' },
  { value: 'red', label: 'Красный' },
  { value: 'orange', label: 'Оранжевый' },
] as const;
